<template>
  <div class="download_zx">
    <!-- 下载中心 -->
    <!-- nav -->
    <index-nav></index-nav>
     <!-- bottom -->
    <index-bottom></index-bottom>
    <div class="content">
      <!-- banner -->
      <div class="banner">
        <img src="/statics/images/info/xz_banner.jpg" alt />
      </div>

      <!-- 总导航 -->
      <div class="allnav inner">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item,index) in cateList"
            :key="index"
            :label="item.text"
            :name="index.toString()"
          ></el-tab-pane>
          <!-- <el-tab-pane label="电厂系列产品" name="second"></el-tab-pane> -->
        </el-tabs>
      </div>
      <div class="downInfo inner">
        <!-- 子导航 -->
        <div class="childnav">
          <div class="desc">
            <img src="/statics/images/info/icon.png" alt />
            <span>资料列表</span>
          </div>
          <el-tabs
            :tab-position="tabPosition"
            v-model="activeChildname"
            @tab-click="childHandleClick"
            v-if="cateList.length!=0"
          >
            <el-tab-pane
              v-for="(item,index) in cateList[cateChild].children"
              :key="index"
              :label="item.text"
              :name="item.value.toString()"
            ></el-tab-pane>
            <!-- <el-tab-pane label="资料分类二" name="two"></el-tab-pane>
            <el-tab-pane label="资料分类三" name="three"></el-tab-pane>
            <el-tab-pane label="资料分类四" name="four"></el-tab-pane>-->
          </el-tabs>
        </div>
        <div class="xz_right">
          <!-- 下载列表 -->
          <div class="xz_list">
            <div class="xz_item" v-for="(item,index) in goodsList" :key="index">
              <div class="left">
                <img src="/statics/images/info/xz_dian.png" alt />
                <span>{{item.file_name}}</span>
              </div>
              <!-- @click="downloadt(item.url,item.file_name)" -->
              <!-- @click="downloadzl(item.id)" -->
              <div class="right">
                <!-- <a :href="adddom(item.url)" :download="item.file_name" target="view_window"> -->
                <!-- 测试服地址 -->
                <!-- <a :href="'http://runbang_server.shanmuzhi.com/api/resource/download?id='+item.id"> -->
                <!-- 正式服地址 -->
                <a :href="'https://console.dzrbhb.com/api/resource/download?id='+item.id">
                  <span>下载</span>
                  <img src="/statics/images/info/download.png" alt />
                </a>
              </div>
            </div>
          </div>
          <!-- 分页 -->
          <div class="fenye clearfix">
            <el-pagination
              v-if="goodsList.length!=0"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pages.size"
              layout="prev, pager, next, jumper"
              :total="goodstotal"
              prev-text="上一页"
              next-text="下一页"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- bottom -->
    <!-- <index-bottom></index-bottom> -->
    <!-- footer -->
    <index-footer></index-footer>
  </div>
</template>

<script>
import indexNav from "./../components/nav";
import indexBottom from "./../components/bottom";
import indexFooter from "./../components/footer";
export default {
  data() {
    return {
      cateList: [], //下载分类
      activeName: "0", //总导航
      cateChild: 0,
      goodsList: [],
      activeChildname: "one", //子导航
      tabPosition: "left", //子导航对齐方式
      currentPage: 1, //当前页数
      goodstotal: 0, //总条数
      cateId: "",
      pages: {
        page: 1,
        size: 10
      }
    };
  },
  components: {
    indexNav,
    indexBottom,
    indexFooter
  },
  created() {
    // 下载分类
    this.getCate();
    function downLoadImg(name, url) {
      var image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function() {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png");
        var a = document.createElement("a");
        a.download = name;
        a.href = url;
        a.click();
      };
      image.src = url;
    }
  },
  methods: {
    // 图片拼接地址
    adddom(src) {
      if (src == "" || src == undefined || src == null) {
        console.log("src地址有问题");
        return "";
      }
      if (src.substr(0, 4).toLowerCase() === "http") {
        return src;
      }
      return this.$url + src;
    },
    // 点击下载
    downloadzl(id) {
      var that = this;
      //  var param = {
      //    id:id
      //  }
      // that.$api.index.download(param).then(function(res) {

      // })
      that.$router.push({
        path: "api/resource/download",
        query: {
          id: id
        }
      });
    },
    getCate() {
      var that = this;
      that.$api.index.resourceCate({}).then(function(res) {
        if (res.code == 200) {
          that.cateList = res.result;
          if (that.cateList && that.cateList[that.cateChild].children) {
            that.activeChildname = that.cateList[
              that.cateChild
            ].children[0].value.toString();
            that.cateId = that.activeChildname;
            that.getList();
          } else {
            that.goodsList = [];
          }
        }
      });
    },
    getList() {
      var that = this;
      var ps = {
        cate_id: that.cateId,
        page: that.pages.page,
        size: that.pages.size
      };
      that.$api.index.resourceList(ps).then(function(res) {
        if (res.code == 200) {
          that.goodsList = res.result.list;
          that.goodstotal = res.result.total;
        }
      });
    },
    // 总导航选中触发
    handleClick(tab, event) {
      // console.log(tab.name);
      var that = this;
      that.cateChild = tab.name;
      if (that.cateList && that.cateList[that.cateChild].children) {
        that.activeChildname = that.cateList[
          that.cateChild
        ].children[0].value.toString();
        that.cateId = that.activeChildname;
        that.getList();
      } else {
        that.goodsList = [];
      }
    },
    // 子导航选中触发
    childHandleClick(tab, event) {
      // console.log(tab.name);
      var that = this;
      that.cateId = tab.name;
      that.pages.page = 1;
      that.getList();
    },
    // 页数改变时触发
    handleCurrentChange(val) {
      // console.log(val);
      this.pages.page = val;
      this.getList();
    },
    // 点击下载
    downloadt(url, name) {
      // console.log(url,name);
      // var a = document.createElement("a");
      // a.download = name;
      // a.href = this.adddom(url);
      // a.click();

      var image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function() {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png");
        var a = document.createElement("a");
        a.download = name;
        a.href = url;
        a.click();
      };
      image.src = url;
    }
  },
  mounted: function() {}
};
</script>

<style>
</style>